import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "trigger"]

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  disconnect() {
    this.removeListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.closeOtherPopovers()
    this.panelTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.positionPanel()
    document.addEventListener("click", this.handleDocumentClick)
    document.addEventListener("keydown", this.handleKeyDown)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.removeListeners()
  }

  isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }

  positionPanel() {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const panel = this.panelTarget
    const panelWidth = panel.offsetWidth
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    let left = triggerRect.left + triggerRect.width / 2 - panelWidth / 2
    left = Math.max(8, Math.min(left, viewportWidth - panelWidth - 8))

    panel.style.left = `${left}px`

    const spaceBelow = viewportHeight - triggerRect.bottom
    const spaceAbove = triggerRect.top
    const panelHeight = panel.offsetHeight

    if (spaceBelow >= panelHeight + 12 || spaceBelow >= spaceAbove) {
      panel.style.top = `${triggerRect.bottom + 8}px`
      panel.classList.remove("bottom-full", "mb-2")
    } else {
      panel.style.top = `${triggerRect.top - panelHeight - 8}px`
    }
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOtherPopovers() {
    document.querySelectorAll("[data-popover-target='panel']").forEach((panel) => {
      if (panel === this.panelTarget) return

      panel.classList.add("hidden")
      const container = panel.closest("[data-controller~='popover']")
      const trigger = container?.querySelector("[data-popover-target='trigger']")
      trigger?.setAttribute("aria-expanded", "false")
    })
  }

  removeListeners() {
    document.removeEventListener("click", this.handleDocumentClick)
    document.removeEventListener("keydown", this.handleKeyDown)
  }
}
